import { Component, Input, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { MuscleGroup } from 'src/models/muscle-group.model';
import { MuscleGroupService } from 'src/services/muscle-group.service';

@Component({
    selector: 'app-select-muscle-group',
    templateUrl: './select-muscle-group.component.html',
    styleUrls: ['./select-muscle-group.component.scss'],
    standalone: false
})
export class SelectMuscleGroupComponent implements OnInit {
  muscleGroups: MuscleGroup[] = [];
  @Input() toggleStates = new Map<string, boolean>();
  @Input() hashtags: string[] = [];
  private destroy$ = new Subject<void>();
  @Input() title = '';
  @Input() preview = false;

  constructor(private muscleGroupService: MuscleGroupService) {}

  async ngOnInit() {
    if (!this.hashtags) this.hashtags = [];
    if (this.hashtags.length) {
      this.toggleHashtags(this.toggleStates);
    }
    this.muscleGroupService
      .getMuscleGroups()
      .pipe(takeUntil(this.destroy$))
      .subscribe((groups) => {
        this.muscleGroups = groups;
      });
  }

  toggleChip(group: string) {
    // Check if the group is already in the map
    const currentState = this.toggleStates.get(group);

    // Update the map with the toggled state
    this.toggleStates.set(group, !currentState);
  }

  toggleChipGroup(muscleGroup: MuscleGroup) {
    //
    const currentState = this.toggleStates.get(muscleGroup.group);

    if (currentState === false) {
      muscleGroup.muscles.forEach((muscle) =>
        this.toggleStates.set(muscle, false)
      );
    }

    this.toggleStates.set(muscleGroup.group, !currentState);
  }

  toggleHashtags(map: Map<string, boolean>): void {
    this.hashtags.forEach((currentValue) => {
      if (map.has(currentValue)) {
        map.set(currentValue, !map.get(currentValue));
      } else {
        map.set(currentValue, true);
      }
    });
  }
}
